import React from "react";
/* Import Boostrap */
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';


class Button extends React.Component { 
    constructor(props) {
        super(props);
        this.state = { 
            class : 'animate-box' 
        }
    }
    componentDidMount = () => {
        var that = this;
        setTimeout(function() {
            that.show();
        }, that.props.wait);
    } 
    show = () => {
        this.setState({class : this.props.className});
    }       
    render () {
        const props = this.props;
        return (
          <p className={this.state.class}>
            <Link to={props.buttonTo} className={props.buttonClass}>{ props.translate(props.buttonName) }</Link>
          </p>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Button);






// WEBPACK FOOTER //
// ./src/components/buttons/button.js